var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"abstract-1-right",attrs:{"src":require('@/assets/abstract1.png'),"height":"528","width":"613"}})
}
var staticRenderFns = []

export { render, staticRenderFns }